export default `float s=2., e;
    for(int i=0;i++<10;){
      p=.3-abs(p-.8);
      p.x < p.z?p=p.zyx:p;
      p.z < p.y?p=p.xzy:p;
      s*=e=1.7;
      p=abs(p)*e-vec3(1.0,50.0,5.0);
    }
    return length(p.xy)/s+.001;
  }`